import {
  Badge,
  Box,
  CircularProgress,
  Grid,
  Stack,
  useMediaQuery,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import DescriptionIcon from "@mui/icons-material/Description";
import React from "react";
import { SwiperSlide } from "swiper/react";
import { useNavigate, NavLink } from "react-router-dom";
import dayjs from "dayjs";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LockIcon from "@mui/icons-material/Lock";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { dashBoardResultContainer } from "../../container/dashBoardResult.container";
import SEO from "../../shared/SEO";
import CircularProgressWithLabel from "../../shared/VSNCircularProgressWithLabel";
import VSNImage from "../../shared/VSNImage";
import VSNLoader from "../../shared/VSNLoader";
import VSNPaper from "../../shared/VSNPaper";
import { VSNSwiper } from "../../shared/VSNSwiper";
import VSNTypography from "../../shared/VSNTypography";
import brain from "../../assets/landing/svg/brain.svg";
import body from "../../assets/landing/svg/body.svg";
import { DashBoardStyle } from "./DashBoardStyle";
import { bgAndBorder } from "../../description/landing.description";
import MultiChart from "./newHomePage/VasanaCard";
import VSNVideoDashBoard from "../../shared/VSNVideoDashBoard";
import VSNModel from "../../shared/VSNModel";
import VSNButton from "../../shared/VSNButton";
import SelectGenderModal from "../assessmentsView/physicalAssessment/SelectGenderModal";
import { FlashIcon, OptionalIcon, RightRoundIcon } from "../../shared/icon";

const DashBoard = () => {
  const {
    result,
    markerInfo,
    readMore,
    toggleReadMore,
    resultInfo,
    userRoleData,
    currentPlayingIndex,
    handleVideoPlay,
    setCurrentPlayingIndex,
    assessmentsCardData,
    notificationData,
    handleNotificationClick,
    modelState,
    NotificationContent,
    handleNotificationClose,
    handleGenderModalClose,
    handleButtonClick,
    ButtonsForGender,
    selectGenderFields,
    handleSelectGender,
    handelGenderChange,
    selectGenderInfo,
    selectGenderInfoError,
  } = dashBoardResultContainer();

  const classes = DashBoardStyle();
  const isLargeScreen = useMediaQuery(
    "(min-width:1366px) and (max-width:1700px)"
  );
  const isMediumScreen = useMediaQuery(
    "(min-width:767px) and (max-width:900px)"
  );
  const isLeptop = useMediaQuery("(min-width:0px) and (max-width:1455px)");
  const navigate = useNavigate();
  if (!markerInfo || !result) {
    return <VSNLoader variant="fullPage" />;
  }

  const splitArray = (str) => {
    const data = str?.map((obj) =>
      obj?.includes(" ") ? splitArray(obj?.split(" ")) : obj
    );
    return data;
  };

  const selectedType = bgAndBorder?.find(
    (item) => item.type === result?.result
  );

  const behavioralAssessment =
    assessmentsCardData?.behavioral_assessment_card_details;
  const PhysicalAssessments =
    assessmentsCardData?.physical_assessment_card_details || {};
  const organizationComposition =
    assessmentsCardData?.organization_composition_card_details;

  const renderAssessmentStatus = (
    status,
    is_locked,
    is_one_pager_available,
    assessment_id,
    assessment_type,
    assessment_taken,
    name,
    type
  ) => {
    const showBtn = !(
      status === "SCHEDULED" ||
      (assessment_taken && status === "COMPLETED" && !is_one_pager_available) ||
      (status === "NOT_SCHEDULED" && !assessment_taken)
    );
    if (!showBtn) {
      return null;
    }
    if (is_locked && status === "COMPLETED") {
      return (
        <VSNTypography
          style={{
            pointerEvents: "none",
            color: "gray",
            display: "flex",
            alignItems: "center",
            fontWeight: 500,
            // flex: "none",
            justifyContent: "flex-end",
            // marginTop: "auto",
            wordBreak: "break-word",
            textAlign: "end",
          }}
        >
          Result Unlocking Soon
          <LockIcon fontSize="small" />
        </VSNTypography>
      );
    }

    if (assessment_taken && assessment_type === "Physical") {
      return (
        <NavLink
          to={`assessments/${assessment_id}`}
          style={{
            color: "var(--primary)",
            display: "flex",
            alignItems: "center",
            fontWeight: 700,
            // flex: "none",
            justifyContent: "flex-end",
            // marginTop: "auto",
            wordBreak: "break-word",
            textAlign: "end",
          }}
        >
          Dive Into Your Report
          <ChevronRightIcon />
        </NavLink>
      );
    }
    if (assessment_taken) {
      return (
        <NavLink
          to={`assessments/${assessment_id}`}
          style={{
            color: "var(--primary)",
            display: "flex",
            alignItems: "center",
            fontWeight: 700,
            // flex: "none",
            justifyContent: "flex-end",
            // marginTop: "auto",
            wordBreak: "break-word",
            textAlign: "end",
          }}
        >
          See full report
          <ChevronRightIcon />
        </NavLink>
      );
    }

    if (!assessment_taken) {
      return (
        <VSNButton
          handleClick={() =>
            handleButtonClick(name, assessment_id, type, assessment_taken)
          }
          className={classes.takeAssessmentBtn}
        >
          take assessment
          <ChevronRightIcon />
        </VSNButton>
      );
    }

    return null;
  };

  const renderResults = (results) => {
    if (results?.[0]) {
      return (
        <Stack direction="row" alignItems="center" margin="auto">
          <Stack className={classes.imgWrapper} mr={2} width="60%">
            <VSNImage src={results[0]?.image} alt="assessment1" />
          </Stack>
          <Stack width="100%" gap={1}>
            <VSNTypography
              fontWeight={600}
              dangerouslySetInnerHTML={{ __html: results[0]?.result }}
            />
            <VSNTypography
              className={classes.assessmentDescription}
              dangerouslySetInnerHTML={{
                __html: results[0]?.trait_description,
              }}
            />
          </Stack>
        </Stack>
      );
    }
    return null;
  };

  const statusBtn = ({ status, is_required, classes, disable }) => {
    if (status === "COMPLETED") {
      return (
        <VSNButton
          className={classes.btnComplete}
          sx={{
            cursor: "not-allowed",
            // marginTop: "auto",
          }}
        >
          <RightRoundIcon />
          Completed
        </VSNButton>
      );
    }
    if (status === "SCHEDULED") {
      return (
        <VSNButton
          className={classes.btnScadule}
          sx={{ cursor: disable ? "not-allowed" : "pointer" }}
        >
          <AccessTimeIcon />
          Assessment Scheduled
        </VSNButton>
      );
    }
    if (status === "NOT_SCHEDULED") {
      return (
        <VSNButton
          className={classes.btnScadule}
          sx={{ cursor: disable ? "not-allowed" : "pointer" }}
        >
          <AccessTimeIcon />
          No Date Scheduled
        </VSNButton>
      );
    }
    if (is_required) {
      return (
        <VSNButton
          className={classes.btnRequired}
          sx={{
            cursor: "not-allowed",
            // marginTop: "auto",
          }}
        >
          <FlashIcon />
          Required
        </VSNButton>
      );
    }
    if (!is_required) {
      return (
        <VSNButton
          className={classes.btnRequired}
          sx={{
            cursor: "not-allowed",
            //  marginTop: "auto"
          }}
        >
          <OptionalIcon />
          Optional
        </VSNButton>
      );
    }
    return "";
  };

  return (
    <>
      <div className={classes.mainLayout}>
        <SEO contentKey="quickView" />
        {isLeptop && (
          <Box
            onClick={() => toggleReadMore()}
            className={classes.notificationIcon}
          >
            <Badge
              badgeContent={
                notificationData?.filter((item) => !item.is_read)?.length
              }
              color="primary"
            >
              <NotificationsNoneIcon
                fontSize="medium"
                sx={{ color: "var(--primary)" }}
              />
            </Badge>
          </Box>
        )}
        <Grid container spacing={isLeptop ? 0 : 3} flexDirection="row-reverse">
          <Grid
            item
            xlg={3}
            lg={4}
            md={5}
            xs={12}
            sx={{ display: isLeptop ? (readMore ? "block" : "none") : "block" }}
          >
            <Stack
              className={classes.quickViewContent2}
              sx={{
                padding: { xxl: 3, lg: 1.5, xs: 2 },
                backgroundColor: "#fff",
                borderRadius: "10px",
                boxShadow: "0px 0px 24px 0px #00000014",
                maxHeight: isLargeScreen ? 600 : 440,
                height: "100%",
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
              >
                <VSNTypography
                  sx={{
                    fontSize: { xxl: 24, lg: 20, xs: 18 },
                    fontWeight: 700,
                    color: "#3A3A40",
                  }}
                >
                  My Notifications
                </VSNTypography>
                {notificationData
                  ?.filter((item) => !item.is_read)
                  ?.map((item) => item.id)?.length > 0 && (
                  <VSNTypography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 700,
                      color: "var(--Tertiary)",
                      cursor: "pointer",
                    }}
                    onClick={() => handleNotificationClick(notificationData)}
                  >
                    Mark all as read
                  </VSNTypography>
                )}
              </Stack>
              <Box className={classes.notificationbox}>
                {notificationData?.length ? (
                  notificationData?.map((noti, index) => (
                    <Stack
                      sx={{
                        "&:hover": {
                          backgroundColor: "var(--TertiaryLighter)",
                        },
                      }}
                      // onClick={() => handleNotificationClick(noti)}
                      key={index}
                      my={0.5}
                      // width="100%"
                      direction="row"
                      className={classes.singleNotification}
                    >
                      <Stack
                        direction="row"
                        flex="none"
                        alignItems="center"
                        gap={0.5}
                        minWidth={30}
                        justifyContent="flex-end"
                        mt={0.5}
                      >
                        {!noti?.is_read && (
                          <Box
                            sx={{
                              width: 10,
                              height: 10,
                              backgroundColor: "var(--Tertiary)",
                              borderRadius: "50%",
                            }}
                          />
                        )}
                        <VSNImage src={noti?.icon} height="14px" width="14px" />
                      </Stack>
                      <Stack width="100%">
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          width="100%"
                        >
                          <VSNTypography
                            sx={{
                              fontSize: "14px",
                              fontWeight: "600",
                              cursor: "pointer",
                            }}
                            pr={2.5}
                            onClick={() => handleNotificationClick(noti)}
                          >
                            {noti?.title}
                          </VSNTypography>

                          {!noti?.is_read && (
                            <VSNTypography
                              sx={{
                                fontSize: "12px",
                                fontWeight: "400",
                                color: "var(--Tertiary)",
                                flex: "none",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleNotificationClick(noti, "markAsRead")
                              }
                            >
                              Mark as Read
                            </VSNTypography>
                          )}
                        </Stack>

                        <VSNTypography
                          sx={{
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "var(--gray)",
                          }}
                        >
                          {dayjs(noti?.created_at).format("lll")}
                        </VSNTypography>
                      </Stack>
                    </Stack>
                  ))
                ) : (
                  <Box className={classes.emptyNotification}>
                    <NotificationsNoneIcon fontSize="large" />
                    <VSNTypography>
                      You do not have any
                      <br /> notifications currently.
                    </VSNTypography>
                  </Box>
                )}
              </Box>
            </Stack>
          </Grid>

          <Grid
            item
            xlg={isLeptop ? 12 : 9}
            lg={isLeptop ? 12 : 8}
            md={isLeptop ? 12 : 7}
            xs={12}
          >
            <Grid
              container
              alignItems="center"
              columnSpacing={{ xxl: 5, md: 4, xs: 3 }}
            >
              <Grid item xlg={4} mdl={4} smd={6} xs={12}>
                <Box mb={{ xs: 6, smd: 4 }}>
                  <VSNPaper
                    className={classes.firstBox}
                    sx={{
                      minHeight: isLargeScreen ? 254 : 264,
                      background: selectedType?.bg,
                      border: `1px solid ${selectedType?.border}`,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Stack
                      direction="row"
                      display={{ xsm: "flex", xs: "block" }}
                      spacing={{ xsm: 3 }}
                    >
                      <Stack className={classes.vasanatype} width="100%">
                        <VSNTypography color="#3A3A40" fontWeight={700}>
                          Your Vasana Type is
                        </VSNTypography>
                        <Box className={classes.vasanaTypeImage} mb={1}>
                          <VSNImage
                            src={resultInfo?.large_icon}
                            alt="large_icon"
                          />
                        </Box>
                        <VSNTypography variant="body2" component="h6">
                          {resultInfo?.tends_to_str
                            ?.split(" ")
                            ?.map((val, i) => (
                              <VSNTypography
                                key={i}
                                variant="span"
                                component="span"
                                className={
                                  splitArray(resultInfo?.tends_to)
                                    ?.flat()
                                    ?.includes(
                                      val?.replace(",", "").replace(".", "")
                                    )
                                    ? classes.marketTends
                                    : ""
                                }
                              >
                                {" "}
                                {val}
                              </VSNTypography>
                            ))}
                        </VSNTypography>
                      </Stack>

                      <Stack
                        width="100%"
                        alignItems={{ xsm: "flex-end", xs: "center" }}
                      >
                        <MultiChart
                          chartType="VasanaCard"
                          height={isLargeScreen ? 150 : 180}
                          width={isLargeScreen ? 150 : 180}
                        />
                      </Stack>
                    </Stack>
                    <Stack className={classes.exploreVasanaType}>
                      <NavLink to="assessments/1">
                        Explore your Vasana Type <ChevronRightIcon />
                      </NavLink>
                    </Stack>
                  </VSNPaper>
                </Box>
              </Grid>

              {userRoleData?.user_profile?.organization_type_id === 2 && (
                <Grid item xlg={4} mdl={4} smd={6} xs={12}>
                  <Box mb={{ smd: 4, xs: 8 }}>
                    <VSNPaper
                      className={classes.firstBox}
                      sx={{
                        minHeight: isLargeScreen ? 254 : 264,
                        boxShadow: "0px 0px 24px 0px #0000000F",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Stack
                        direction="column"
                        justifyContent="space-between"
                        display={{ xsm: "flex", xs: "block" }}
                      >
                        <VSNTypography
                          fontWeight="700"
                          fontSize={{ xxl: 16, xs: 14 }}
                          mb={{ xsm: 0, xs: 2 }}
                        >
                          Your Organization’s Vasana Composition
                        </VSNTypography>
                        <Stack direction="row">
                          <MultiChart
                            chartType="Organization"
                            data={organizationComposition}
                            disabled
                            height={
                              isLargeScreen ? 150 : isMediumScreen ? 150 : 200
                            }
                            width={
                              isLargeScreen ? 150 : isMediumScreen ? 150 : 200
                            }
                          />
                          <Stack
                            direction="column"
                            justifyContent="space-around"
                          >
                            <Stack>
                              <VSNTypography
                                fontWeight="400"
                                fontSize={{ xxl: 16, xs: 14 }}
                              >
                                Dominant Type:
                              </VSNTypography>
                              <Box
                                sx={{
                                  width: "52px",
                                  marginLeft: "auto",
                                }}
                              >
                                {organizationComposition?.dominating_type ? (
                                  <VSNImage
                                    src={`https://vasana-static.s3.us-east-1.amazonaws.com/images/vasana/${organizationComposition?.dominating_type}/${organizationComposition?.dominating_type}-large.svg`}
                                    alt="sa logo"
                                  />
                                ) : (
                                  "-"
                                )}
                              </Box>
                            </Stack>
                            <Stack>
                              <VSNTypography
                                fontWeight="400"
                                fontSize={{ xxl: 16, xs: 14 }}
                              >
                                Scarce Type:
                              </VSNTypography>
                              <Box
                                sx={{
                                  width: "52px",
                                  marginLeft: "auto",
                                }}
                              >
                                {organizationComposition?.scarce_type ? (
                                  <VSNImage
                                    src={`https://vasana-static.s3.us-east-1.amazonaws.com/images/vasana/${organizationComposition?.scarce_type}/${organizationComposition?.scarce_type}-large.svg`}
                                    alt="ra logo"
                                  />
                                ) : (
                                  "-"
                                )}
                              </Box>
                            </Stack>
                          </Stack>
                        </Stack>
                      </Stack>
                    </VSNPaper>
                  </Box>
                </Grid>
              )}

              {(userRoleData?.user_profile?.organization_type_id === 1 ||
                userRoleData?.user_profile?.organization_type_id === 3 ||
                userRoleData?.user_profile?.organization_type_id === 2) && (
                <Grid item xlg={4} mdl={4} smd={6} xs={12}>
                  <Box mb={{ smd: 4, xs: 8 }} sx={{ position: "relative" }}>
                    <VSNPaper
                      className={`${classes.firstBox} ${classes.backImageOne}`}
                    />

                    <VSNPaper
                      className={`${classes.firstBox} ${classes.backImageTwo}`}
                    />
                    <VSNPaper
                      className={`${classes.firstBox} ${classes.backImageThree}`}
                    />
                    <VSNPaper
                      className={`${classes.firstBox} ${classes.backImageFour}`}
                    />
                    <VSNPaper
                      className={classes.firstBox}
                      sx={{
                        minHeight: isLargeScreen ? 254 : 264,
                        boxShadow: "0px 0px 24px 0px #0000000F",
                      }}
                    >
                      <Box position="relative">
                        <Stack
                          direction="row"
                          spacing={1.4}
                          className={classes.customArrow}
                        >
                          <div className="swiper-button image-swiper-button-next">
                            <ArrowBackIosNewIcon fontSize="small" />
                          </div>
                          <div className="swiper-button image-swiper-button-prev">
                            <ArrowForwardIosIcon fontSize="small" />
                          </div>
                        </Stack>
                        <VSNSwiper
                          className={classes.personalityMain}
                          navigation={{
                            prevEl: ".image-swiper-button-next",
                            nextEl: ".image-swiper-button-prev",
                            disabledClass: "swiper-button-disabled",
                          }}
                          spaceBetween={20}
                          breakpoints={{
                            0: {
                              slidesPerView: 1,
                            },
                            767: {
                              slidesPerView: 1,
                            },
                          }}
                        >
                          <SwiperSlide key="static-card-behavioral">
                            <Stack
                              direction="row"
                              alignItems="center"
                              gap={1}
                              mb={2}
                            >
                              <Box>
                                <VSNImage src={brain} />
                              </Box>
                              <VSNTypography
                                sx={{
                                  fontSize: 16,
                                  fontWeight: 700,
                                  color: "var(--secondary)",
                                }}
                              >
                                Your Behavioral Assessments
                              </VSNTypography>
                            </Stack>
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                              spacing={{ xsm: 2, xs: 1 }}
                              alignItems="center"
                            >
                              <Stack>
                                <Stack mb={3}>
                                  <VSNTypography
                                    sx={{
                                      fontSize: "14px",
                                      lineHeight: "1.29",
                                      fontWeight: 600,
                                      color: "#A5A9BD",
                                    }}
                                  >
                                    Next Assessment
                                  </VSNTypography>
                                  <VSNTypography
                                    sx={{
                                      lineHeight: "1.31",
                                      fontSize: "16px",
                                      fontWeight: 700,
                                      height: 42,
                                    }}
                                  >
                                    {behavioralAssessment
                                      ?.all_assessments_details?.length > 0
                                      ? behavioralAssessment
                                          ?.all_assessments_details[0]?.name
                                      : ""}
                                  </VSNTypography>
                                </Stack>
                                <Stack direction="row" gap={1}>
                                  <Box>
                                    <VSNTypography
                                      sx={{
                                        fontSize: 20,
                                        lineHeight: "1.3",
                                        fontWeight: 700,
                                        color: "#898994",
                                      }}
                                    >
                                      {behavioralAssessment?.total_assessment}
                                    </VSNTypography>
                                    <VSNTypography
                                      sx={{
                                        fontSize: { xsm: 14, xs: 12 },
                                        fontWeight: 500,
                                        lineHeight: "1.3",
                                      }}
                                    >
                                      Total Assessments
                                    </VSNTypography>
                                  </Box>
                                  <Box
                                    sx={{
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <VSNTypography
                                      sx={{
                                        fontSize: 20,
                                        lineHeight: "1.3",
                                        fontWeight: 700,
                                        color: "#898994",
                                      }}
                                    >
                                      {
                                        behavioralAssessment?.total_pending_assessment
                                      }
                                    </VSNTypography>
                                    <VSNTypography
                                      sx={{
                                        fontSize: { xsm: 14, xs: 12 },
                                        fontWeight: 500,
                                        lineHeight: "1.3",
                                      }}
                                    >
                                      Pending Assessments
                                    </VSNTypography>
                                  </Box>
                                </Stack>
                              </Stack>
                              <Box sx={{ height: "100px", width: "100px" }}>
                                <MultiChart
                                  chartType="Progress"
                                  ratio={
                                    behavioralAssessment?.completion_ratio ?? 0
                                  }
                                  color="#E87637"
                                  bgColor="#FEDDCB"
                                  disabled
                                />
                              </Box>
                            </Stack>
                            <Stack className={classes.viewAll}>
                              <NavLink to="assessments?type=all">
                                View All <ChevronRightIcon />
                              </NavLink>
                            </Stack>
                          </SwiperSlide>

                          {behavioralAssessment?.all_assessments_details?.map(
                            (
                              {
                                name,
                                is_locked,
                                is_one_pager_available,
                                status,
                                assessment_id,
                                all_results,
                                assessment_type,
                                assessment_taken,
                                type,
                                is_required,
                              },
                              i
                            ) => (
                              <SwiperSlide key={i}>
                                <Stack
                                  sx={{
                                    borderRadius: "10px",
                                    minHeight: 216,
                                  }}
                                >
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                  >
                                    <VSNTypography
                                      fontSize={{ xl: 18, xs: 16 }}
                                      fontWeight={700}
                                    >
                                      {name}
                                    </VSNTypography>
                                  </Stack>
                                  {renderResults(all_results)}
                                  <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    flexWrap="wrap"
                                    gap={1}
                                  >
                                    {statusBtn({
                                      status,
                                      is_required,
                                      classes,
                                      assessment_taken,
                                    })}
                                    {renderAssessmentStatus(
                                      status,
                                      is_locked,
                                      is_one_pager_available,
                                      assessment_id,
                                      assessment_type,
                                      assessment_taken,
                                      name,
                                      classes,
                                      type
                                    )}
                                  </Stack>
                                </Stack>
                              </SwiperSlide>
                            )
                          )}
                        </VSNSwiper>
                      </Box>
                    </VSNPaper>
                  </Box>
                </Grid>
              )}

              {(userRoleData?.user_profile?.organization_type_id === 1 ||
                userRoleData?.user_profile?.organization_type_id === 3) && (
                <Grid item xlg={4} mdl={4} smd={6} xs={12}>
                  <Box mb={{ xs: 3, md: 4 }} sx={{ position: "relative" }}>
                    <VSNPaper
                      className={`${classes.firstBox} ${classes.backImageOne}`}
                    />

                    <VSNPaper
                      className={`${classes.firstBox} ${classes.backImageTwo}`}
                    />
                    <VSNPaper
                      className={`${classes.firstBox} ${classes.backImageThree}`}
                    />
                    <VSNPaper
                      className={`${classes.firstBox} ${classes.backImageFour}`}
                    />
                    <VSNPaper
                      className={classes.firstBox}
                      sx={{
                        minHeight: isLargeScreen ? 254 : 264,
                        boxShadow: "0px 0px 24px 0px #0000000F",
                      }}
                    >
                      <Box position="relative">
                        <Stack
                          direction="row"
                          spacing={1.4}
                          className={classes.customArrow1}
                        >
                          <div className="swiper-button1 image-swiper-button-next1">
                            <ArrowBackIosNewIcon fontSize="small" />
                          </div>
                          <div className="swiper-button1 image-swiper-button-prev1">
                            <ArrowForwardIosIcon fontSize="small" />
                          </div>
                        </Stack>
                        <VSNSwiper
                          className={classes.personalityMain1}
                          navigation={{
                            prevEl: ".image-swiper-button-next1",
                            nextEl: ".image-swiper-button-prev1",
                            disabledClass: "swiper-button-disabled1",
                          }}
                          spaceBetween={20}
                          breakpoints={{
                            0: {
                              slidesPerView: 1,
                            },
                            767: {
                              slidesPerView: 1,
                            },
                          }}
                        >
                          <SwiperSlide key="static-card-physical">
                            <Stack
                              direction="row"
                              alignItems="center"
                              gap={1}
                              mb={2}
                            >
                              <Box>
                                <VSNImage src={body} alt="body" />
                              </Box>
                              <VSNTypography
                                sx={{
                                  fontSize: 16,
                                  fontWeight: 700,
                                  color: "var(--Tertiary)",
                                }}
                              >
                                Your Physical Assessments
                              </VSNTypography>
                            </Stack>
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                              spacing={{ xsm: 2, xs: 1 }}
                              alignItems="center"
                            >
                              <Stack>
                                {PhysicalAssessments?.schedule_for ? (
                                  <Stack mb={3} minHeight={61}>
                                    <VSNTypography
                                      sx={{
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        lineHeight: "1.29",
                                        color: "#A5A9BD",
                                      }}
                                    >
                                      Scheduled for
                                    </VSNTypography>
                                    <VSNTypography
                                      sx={{
                                        fontSize: "16px",
                                        fontWeight: 700,
                                        lineHeight: "1.31",
                                        height: 42,
                                      }}
                                    >
                                      {PhysicalAssessments?.schedule_for
                                        ? dayjs(
                                            PhysicalAssessments?.schedule_for
                                          ).format("MMMM D, YYYY")
                                        : ""}
                                    </VSNTypography>
                                  </Stack>
                                ) : (
                                  <Stack mb={3} minHeight={61}>
                                    <VSNTypography
                                      sx={{
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        lineHeight: "1.29",
                                        color: "#A5A9BD",
                                      }}
                                    >
                                      Assessments not yet scheduled
                                    </VSNTypography>
                                  </Stack>
                                )}
                                <Stack direction="row" gap={1}>
                                  <Box>
                                    <VSNTypography
                                      sx={{
                                        fontSize: 20,
                                        fontWeight: 700,
                                        lineHeight: "1.3",
                                        color: "#898994",
                                      }}
                                    >
                                      {PhysicalAssessments?.total_assessment}
                                    </VSNTypography>
                                    <VSNTypography
                                      sx={{
                                        fontSize: { xsm: 14, xs: 12 },
                                        fontWeight: 500,
                                        lineHeight: "1.3",
                                      }}
                                    >
                                      Total Assessments
                                    </VSNTypography>
                                  </Box>
                                  <Box
                                    sx={{
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <VSNTypography
                                      sx={{
                                        fontSize: 20,
                                        lineHeight: "1.3",
                                        fontWeight: 700,
                                        color: "#898994",
                                      }}
                                    >
                                      {
                                        PhysicalAssessments?.total_pending_assessment
                                      }
                                    </VSNTypography>
                                    <VSNTypography
                                      sx={{
                                        fontSize: { xsm: 14, xs: 12 },
                                        fontWeight: 500,
                                        lineHeight: "1.3",
                                      }}
                                    >
                                      Pending Assessments
                                    </VSNTypography>
                                  </Box>
                                </Stack>
                              </Stack>
                              <Box sx={{ height: "100px", width: "100px" }}>
                                <MultiChart
                                  chartType="Progress"
                                  ratio={
                                    PhysicalAssessments?.completion_ratio ?? 0
                                  }
                                  color="#555FDD"
                                  bgColor="#E6E7FA"
                                  disabled
                                />
                              </Box>
                            </Stack>
                            <Stack className={classes.viewAll}>
                              <NavLink to="assessments?type=physical">
                                View All <ChevronRightIcon />
                              </NavLink>
                            </Stack>
                          </SwiperSlide>

                          {PhysicalAssessments?.all_assessments_details?.map(
                            (
                              {
                                name,
                                is_locked,
                                is_one_pager_available,
                                status,
                                assessment_id,
                                all_results,
                                assessment_type,
                                assessment_taken,
                                type,
                                is_required,
                              },
                              i
                            ) => (
                              <SwiperSlide key={i}>
                                <Stack
                                  sx={{
                                    borderRadius: "10px",
                                    minHeight: 216,
                                  }}
                                >
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                  >
                                    <VSNTypography
                                      fontSize={{ xl: 18, xs: 16 }}
                                      fontWeight={700}
                                    >
                                      {name}
                                    </VSNTypography>
                                  </Stack>

                                  {renderResults(all_results)}
                                  <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    flexWrap="wrap"
                                    gap={1}
                                  >
                                    {statusBtn({
                                      status,
                                      is_required,
                                      classes,
                                      assessment_taken,
                                    })}
                                    {renderAssessmentStatus(
                                      status,
                                      is_locked,
                                      is_one_pager_available,
                                      assessment_id,
                                      assessment_type,
                                      assessment_taken,
                                      name,
                                      classes,
                                      type
                                    )}
                                  </Stack>
                                </Stack>
                              </SwiperSlide>
                            )
                          )}
                        </VSNSwiper>
                      </Box>
                    </VSNPaper>
                  </Box>
                </Grid>
              )}
            </Grid>

            <Stack mt={{ md: 0, xs: 3 }}>
              <Box>
                <Stack direction="row" className={classes.combinationHeading}>
                  <Box>
                    <VSNTypography
                      variant="h5"
                      component="h5"
                      className={classes.lgHeading}
                      mb={1}
                    >
                      Your Vasana Type Composition
                    </VSNTypography>
                  </Box>
                </Stack>
                <Stack
                  direction="row"
                  flexWrap="wrap"
                  className={classes.vassnaTypeBox}
                >
                  {Object?.entries(markerInfo)
                    ?.filter(([key, val]) =>
                      ["sa", "re", "ga", "ma"].includes(key)
                    )
                    ?.map(([key, val], i) => (
                      <NavLink to={`/${key}`} key={i}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          className={`${
                            classes.personalityRange
                          } ${`${key}Per`}`}
                          key={i}
                        >
                          <Box
                            style={{ color: val?.color_code?.toString() }}
                            className={`${classes.range}`}
                          >
                            <CircularProgressWithLabel
                              {...{ value: result?.[`${key}_percentage`] }}
                            />
                          </Box>
                          <VSNTypography variant="h4" component="h4">
                            <Box>
                              <VSNImage src={val?.large_icon} alt="yss" />
                            </Box>
                          </VSNTypography>
                          <VSNTypography variant="body1" component="p">
                            {val.quality?.join(", ")}
                          </VSNTypography>
                        </Stack>
                      </NavLink>
                    ))}
                </Stack>
              </Box>
            </Stack>
          </Grid>
        </Grid>

        <Box my={3.5}>
          <Box className={classes.videosMain}>
            <VSNTypography
              variant="h5"
              component="h5"
              className={classes.lgHeading}
              mb={1}
            >
              Some Content Curated For You
            </VSNTypography>

            <Box
              className={`${classes.yourPersonalitySliderMain} ${classes.videoSlider}`}
            >
              <VSNSwiper
                pagination
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  600: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  992: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                  1440: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                  },
                  1600: {
                    slidesPerView: 5,
                    spaceBetween: 25,
                  },
                }}
              >
                {markerInfo?.[
                  result?.result?.toLowerCase()
                ]?.vasana_content_to_accelerate_your_performance
                  ?.slice(0, 4)
                  ?.map(({ url, description, title, thumbnail }, i) => (
                    <SwiperSlide
                      className={classes.personalityBoxMain}
                      key={`video-index-${i}`}
                    >
                      <VSNPaper className={classes.videosBox}>
                        <VSNVideoDashBoard
                          url={url}
                          thumbnail={thumbnail}
                          key={i}
                          isPlaying={currentPlayingIndex === i}
                          onPlay={() => handleVideoPlay(i)}
                          title={title}
                          description={description}
                        />
                      </VSNPaper>
                    </SwiperSlide>
                  ))}
              </VSNSwiper>
            </Box>
          </Box>
        </Box>
      </div>

      {modelState?.NotificationReadModal && (
        <VSNModel
          open={modelState?.NotificationReadModal}
          onClose={() => {
            handleNotificationClose();
          }}
          disableEnforceFocus
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          mobileDrawer
          className={classes.NotificationReadModal}
          title={NotificationContent?.title ?? ""}
        >
          <Box p={4} mx={-3} maxHeight="500px" sx={{ overflowY: "auto" }}>
            <div
              dangerouslySetInnerHTML={{
                __html: NotificationContent?.content,
              }}
            />
          </Box>
        </VSNModel>
      )}

      {modelState?.GenderChangeModal && (
        <VSNModel
          open={modelState?.GenderChangeModal}
          onClose={() => {
            handleGenderModalClose();
          }}
          disableEnforceFocus
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          mobileDrawer
          className={classes.GenderChangeModal}
        >
          <SelectGenderModal
            buttons={ButtonsForGender}
            selectGenderFields={selectGenderFields}
            handleSelectGender={handleSelectGender}
            {...{
              handelGenderChange,
              selectGenderInfo,
              selectGenderInfoError,
            }}
          />
        </VSNModel>
      )}
    </>
  );
};

export default DashBoard;
